module.exports = __webpack_public_path__ + "img/Mask group.85b51f79.svg";